<template>
  <el-table-column
    prop="plate_number"
    sortable
    label="Rendszám"
    fixed
    show-overflow-tooltip
    min-width="100px"
  >
    <template slot-scope="scope">
      {{ scope.row.plate_number }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'plate_number',
  };
</script>
